import React from 'react';
import { XIcon } from 'lucide-react';
interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  isLoading?: boolean;
}
export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Deletion',
  message = 'Are you sure you want to permanently delete this product? This action cannot be undone.',
  isLoading = false
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" data-id="element-1157">
      <div className="w-full max-w-md bg-white dark:bg-[#162825] rounded-xl shadow-lg overflow-hidden" data-id="element-1158">
        <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-[#1A3330]" data-id="element-1159">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-[#F8FAF9]" data-id="element-1160">
            {title}
          </h3>
          <button onClick={onClose} disabled={isLoading} className="text-gray-500 dark:text-[#7A8F8A] hover:text-gray-700 dark:hover:text-[#B0C1BD] transition-colors" data-id="element-1161">
            <XIcon className="h-5 w-5" data-id="element-1162" />
          </button>
        </div>
        <div className="p-6" data-id="element-1163">
          <div className="mb-6" data-id="element-1164">
            <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-1165">{message}</p>
          </div>
          <div className="flex justify-end space-x-3" data-id="element-1166">
            <button onClick={onClose} disabled={isLoading} className="px-4 py-2 bg-gray-100 dark:bg-[#1A3330] text-gray-700 dark:text-[#B0C1BD] rounded-lg text-sm font-medium hover:bg-gray-200 dark:hover:bg-[#214541] transition-colors disabled:opacity-50" data-id="element-1167">
              Cancel
            </button>
            <button onClick={onConfirm} disabled={isLoading} className="px-4 py-2 bg-red-600 dark:bg-red-500 text-white rounded-lg text-sm font-medium hover:bg-red-700 dark:hover:bg-red-600 transition-colors disabled:opacity-50 flex items-center" data-id="element-1168">
              {isLoading ? <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-1169">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-1170"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1171"></path>
                  </svg>
                  Deleting...
                </> : 'Delete Permanently'}
            </button>
          </div>
        </div>
      </div>
    </div>;
};